<template>
  <div class="d-flex flex-wrap mx-2">
    <!-- form inputs -->
    <v-checkbox
      v-model="download.jsonFiles"
      class="mr-2 my-1"
      label="Archivos JSON"
      hide-details="auto"
    ></v-checkbox>
    <v-checkbox
      v-model="download.pdfFiles"
      class="mr-2 my-1"
      label="Archivos PDF"
      hide-details="auto"
    ></v-checkbox>
    <v-btn
      @click.stop="onClickDownload"
      color="primary"
      :disabled="!download.jsonFiles && !download.pdfFiles"
    >
      <v-icon>mdi-download</v-icon>
      Descargar
    </v-btn>

    <!-- printable component -->
    <div
      v-for="(printedComponent, index) in printedComponents"
      :key="index"
      style="max-height: 1px"
    >
      <component
        :key="`${printedComponent.codGen}-${printedComponent.id_print}`"
        :is="printedComponent.component"
        :downloadJSON="download.jsonFiles"
        :downloadPDF="download.pdfFiles"
        :dataProps="printedComponent.data"
        :autoPrint="true"
        :id_print="printedComponent.id_print"
        @autoPrintCompleted="removeComponent"
        @autoPrintError="cancelPrinting"
      />
    </div>

    <!-- alerts -->
    <alerts
      v-if="alert.show"
      @close_alert="closeAlert"
      @accept_alert="acceptAlert"
      :properties="alert"
    >
    </alerts>

    <!-- loading component -->
    <block v-model="loading"></block>
  </div>
</template>

<script>
import Block from "@/components/Block";
import Alerts from "@/components/Alerts";
import PrintPosFaR2NotVisible from "../ReportsAndPrintings/PrintPosFaR2NotVisible.vue";

export default {
  name: "PrintPdfJsonR2",
  props: {
    data: {
      type: Array,
      default: null,
    },
    reloadData: {
      type: Function,
      default: null
    }
  },
  components: { Block, Alerts, PrintPosFaR2NotVisible },

  data() {
    return {
      loading: false,
      invoices: [],
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      download: {
        jsonFiles: false,
        pdfFiles: false,
      },
      userinfo: JSON.parse(localStorage.getItem("user")),
      branchinfo: JSON.parse(localStorage.getItem("branch")),
      tempData: [],
      print: {
        show: false,
        data: [],
      },
      print2: {
        show: false,
        data: [],
      },
      invoiceDteJson: null,
      printedComponents: [],
      invoiceDocRelated: [],
      invoiceSelectItems: [],
      invoiceItems: [],
      searchbusiness: {},
      infobusiness: {},
      branchData: {},
      showPrintedComponents: false,
      positionArray: 0,
      maxPositionArray: 0,
      invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito"],
      paymentMethod: ["Pendiente", "Efectivo", "Cheque", "Transferencia", "Tarjeta de Crédito", "Otro"],
      entidades: {
          '14': {
              emisor: 'emisor',
              receptor: 'sujetoExcluido'
          },
          '15': {
              emisor: 'donatario',
              receptor: 'donante'
          }
      },
    };
  },
  mounted() {
    this.searchbusiness.branch =
      JSON.parse(localStorage.getItem("user")).branch || "";
    this.searchbusiness.business =
      JSON.parse(localStorage.getItem("user")).businessid || "";
    this.initialDataCallPre();
  },
  methods: {
    async removeComponent(id) {
      this.printedComponents = this.printedComponents.filter(
        (x) => x.id_print !== id
      );
      this.positionArray++;

      if (this.positionArray < this.maxPositionArray) {
        const invoice = this.data[this.positionArray];
        await this.SendToPrint(invoice);
      } else {
        this.$emit("setLoading", false);
        this.$emit("displaySuccessAlert");
      }
    },
    cancelPrinting(err) {
      console.log(err);
      this.$emit("setLoading", false);

      this.$emit("displayErrorAlert", err);
    },
    async initialDataCallPre() {
      await this.getInfoBranch()
    },
    async initialDataCall(InvoiceType, ID_Invoice) {
      if (InvoiceType == "DNC" || InvoiceType == "DND") {
        const [
          headerFooter,
          //infoBranch,
          invoiceProductItems,
          invoiceServiceItems,
          dteJsonHeaderInfo,
          docRelated,
        ] = await Promise.all([
          this.getHeaderFooter(),
          //this.getInfoBranch(),
          this.getInvoiceProductItems(ID_Invoice),
          this.getInvoiceServiceItems(ID_Invoice),
          this.getDteJsonHeaderInfo(ID_Invoice),
          this.getDocRelated(ID_Invoice),
        ]);

        let dte = dteJsonHeaderInfo;

        return {
          headerFooter,
          //infoBranch,
          invoiceProductItems,
          invoiceServiceItems,
          dte,
          docRelated,
        };
      } else {
        const [
          headerFooter,
          //infoBranch,
          invoiceProductItems,
          invoiceServiceItems,
          dteJsonHeaderInfo,
          docRelated,
        ] = await Promise.all([
          this.getHeaderFooter(),
          //this.getInfoBranch(),
          this.getInvoiceProductItems(ID_Invoice),
          this.getInvoiceServiceItems(ID_Invoice),
          this.getDteJsonHeaderInfo(ID_Invoice),
          this.getDocRelated(ID_Invoice),
        ]);
        let dte = dteJsonHeaderInfo;

        return {
          headerFooter,
          //infoBranch,
          invoiceProductItems,
          invoiceServiceItems,
          dte,
          docRelated,
        };
      }
    },

    getHeaderFooter() {
      return new Promise((resolve, reject) => {
        let search = {
          ID_Branch: this.ID_Branch,
          ID_Business: this.ID_Business,
        };
        this.$API.HF.getHF(search)
          .then((data) => {
            let header = [],
              footer = [];
            header = data.filter((x) => x.State == "1" && x.Type == "Header");
            let headerData =
              header.length > 0 ? JSON.parse(header[0].Body).html : "";
            footer = data.filter((x) => x.State == "1" && x.Type == "Footer");
            let footerData =
              footer.length > 0 ? JSON.parse(footer[0].Body).html : "";
            resolve({ header: headerData, footer: footerData });
          })
          .catch((err) => {
            console.log(err);
            reject(err``);
          });
      });
    },

    async getInfoBranch() {
      this.$API.branches
        .findSpecificBranch(this.searchbusiness)
        .then(async (res) => {
          // console.log("res es:", res)
          const infobusiness = res[0];
          const currentBranch = JSON.parse(localStorage.getItem("branch"));
          this.branchData = {
            AuthFeMode: infobusiness.AuthFeMode,
            BusinessBillingNRC: infobusiness.BusinessBillingNRC,
            BusinessBillingNIT: infobusiness.BusinessBillingNIT,
            BusinessBillingName: infobusiness.BusinessBillingName,
            ...currentBranch,
          };

          //DOWNLOAD LOGO AND BANNER.
          const img = this.branchData.BranchBannerPath;
          const logo = this.branchData.BranchLogoPath;

          if (img) {
            const { imageBase64: bannerImageBase64 } = await this.$API.utilities.getImageInBase64({ file: img });
            this.branchData.BranchBannerPath = `${bannerImageBase64}`;
          }

          if (logo) {
            const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ file: logo });
            this.branchData.BranchLogoPath = `${logoImageBase64}`;
          }

        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getDteJsonHeaderInfo(ID_Invoice) {
      return new Promise((resolve, reject) => {
        this.$API.invoices
          .getDteJsonHeaderByInvoice(ID_Invoice)
          .then((response) => {
            if (response.length > 0) resolve(response[0]);
            else resolve(null);
          })
          .catch((err) => {
            console.log("Error", err);
            reject(err);
          });
      });
    },

    addNDorNC(data) {
      data.data.IsNDorNC = true;
      this.showInvoice = data;
    },

    showInvoiceDetail(data) {
      data.data.IsNDorNC = false;
      this.showInvoice = data;
    },

    async getDocRelated(ID_Invoice) {
      return new Promise((resolve, reject) => {
        let invoiceDocRelated;
        this.$API.invoices
          .getDocRelatedByInvoice(ID_Invoice)
          .then((response) => {
            invoiceDocRelated = response;
            // console.log("DOC RELATED", invoiceDocRelated)
            resolve(invoiceDocRelated);
          })
          .catch((err) => {
            console.log("Error", err);
            reject(invoiceDocRelated);
          });
      });
    },

    async getInvoiceProductItems(ID_Invoice) {
      return new Promise((resolve, reject) => {
        const invoiceItems = [];
        let totalItemsPrice = 0;

        this.$API.invoices
          .getInvoiceProductItems(ID_Invoice)
          .then((response) => {
            if (response != []) {
              response.map((el) => {
                invoiceItems.push(el);
                totalItemsPrice +=
                  el.ItemGravada + el.ItemExenta + el.ItemNoSuj;
              });
              resolve({ invoiceItems, totalItemsPrice });
            } else {
              resolve({ invoiceItems: [], totalItemsPrice: 0 });
            }
          })
          .catch((err) => {
            console.log("Error", err);
            reject(err);
          });
      });
    },

    async getInvoiceServiceItems(ID_Invoice) {
      return new Promise((resolve, reject) => {
        const invoiceItems = [];
        let totalItemsPrice = 0;

        this.$API.invoices
          .getInvoiceServiceItems(ID_Invoice)
          .then((response) => {
            if (response != []) {
              response.map((el) => {
                invoiceItems.push(el);
                totalItemsPrice +=
                  el.ItemGravada + el.ItemExenta + el.ItemNoSuj;
              });
              resolve({ invoiceItems, totalItemsPrice });
            } else {
              resolve({ invoiceItems: [], totalItemsPrice: 0 });
            }
          })
          .catch((err) => {
            console.error("Error", err);
            reject(err);
          });
      });
    },
    assignBody( body, invoiceType ) {
      for( const index in body ) {
        const { ventaExenta, ventaNoSuj, ventaGravada } = body[ index ];
        body[ index ].ventaExenta = ventaExenta ? ventaExenta : 0 ;
        body[ index ].ventaNoSuj = ventaNoSuj ? ventaNoSuj : 0 ;
        body[ index ].ventaGravada =
        ventaGravada ?
            ventaGravada :
            invoiceType === '14' ? 
            body[ index ].compra :
            0 ;
      }
    },
    assignSummary( summary, invoiceType ) {
      const { subTotalVentas } = summary;
      summary.subTotalVentas =
        subTotalVentas ?
        subTotalVentas :
        invoiceType === '14' ? 
          summary.subTotal :
          0 ;
    },
    manageprint(invoice) {
      try {
        // Push the component data to the printedComponents array
        const { jsonFaMH: { dteJson }, respuestaMh: respuestaMhString, NumeroControl, InvoiceType: type, ID_R2_Invoice, jsonRecepcionDte: recepcionDte } = invoice;
  
        const respuestaMh = JSON.parse( respuestaMhString );
  
        const entidadEmisora = this.entidades[ dteJson.identificacion.tipoDte ]?.emisor ? this.entidades[ dteJson.identificacion.tipoDte ]?.emisor : 'emisor';
        const entidadReceptora = this.entidades[ dteJson.identificacion.tipoDte ]?.receptor ? this.entidades[ dteJson.identificacion.tipoDte ]?.receptor : 'receptor';
  
        this.assignBody( dteJson.cuerpoDocumento, dteJson.identificacion.tipoDte );
        this.assignSummary( dteJson.resumen, dteJson.identificacion.tipoDte );
  
        const iva = dteJson.resumen.tributos ? dteJson.resumen.tributos.find( current => current.codigo === '20' ) : {};
  
        if(Object.keys( iva ).length > 0) {
            if(iva.valor) {
                dteJson.resumen.totalIva = iva.valor;
            }
            else {
                dteJson.resumen.totalIva = 0;
            }
        }
        else {
            dteJson.resumen.totalIva = 0;
        }
  
        let invoiceDate = ''
  
        if( respuestaMh.fhProcesamiento ) {
            invoiceDate = respuestaMh.fhProcesamiento.slice(0, 10);
        } else { 
            const partsOfDate = dteJson.identificacion.fecEmi.split( '-' );
            invoiceDate = `${ partsOfDate[ 2 ] }/${ partsOfDate[ 1 ] }/${ partsOfDate[ 0 ] }`
        }
  
        const dataPrint = {
          branch: JSON.parse(localStorage.getItem("branch")),
          header: {
            businessName: dteJson[ entidadEmisora ].nombre,
            businessComercialName: dteJson[ entidadEmisora ].nombreComercial,
            businessActivity: dteJson[ entidadEmisora ].descActividad.concat(' (', dteJson[ entidadEmisora ].codActividad, ')'),
            businessAddress: dteJson[ entidadEmisora ].direccion.complemento,
            //Agregar pais, departamento y municipio
            businessPhone: dteJson[ entidadEmisora ].telefono,
            businessMobile: dteJson[ entidadEmisora ].celular || dteJson[ entidadEmisora ].movil || '',
            businessEmail: dteJson[ entidadEmisora ].correo,
            businessNIT: dteJson[ entidadEmisora ].nit,
            businessNRC: dteJson[ entidadEmisora ].nrc,
            invoiceMHEnv: dteJson.identificacion.ambiente,
            invoiceCodGen: respuestaMh.codigoGeneracion,
            invoiceSelloRecepcion:  respuestaMh.selloRecibido,
            invoiceNumControl: NumeroControl,
            invoiceDate,
            invoiceType: type,
            invoiceID: ID_R2_Invoice,
            invoiceModel: dteJson.identificacion.tipoModelo,
            invoiceOperation: dteJson.identificacion.tipoOperacion,
            invoiceMoney: dteJson.identificacion.tipoMoneda,
            invoiceTypeDte: dteJson.identificacion.tipoDte,
            invoicePayment: dteJson.resumen.pagos ? this.paymentMethod[parseInt(dteJson.resumen.pagos[0].codigo)] : '',
            invoiceDocRelated: dteJson.documentoRelacionado,
            invoiceDocs: dteJson.otrosDocumentos,
            invoiceName: dteJson[ entidadReceptora ].nombre,
            invoiceAddress: dteJson[ entidadReceptora ].direccion?.complemento || dteJson[ entidadReceptora ].complemento,
            //Agregar pais, departamento, municipio
            invoiceTypeDoc: dteJson[ entidadReceptora ].TipoDocumento,
            invoiceNumDoc: dteJson[ entidadReceptora ].numDocumento,
            invoiceNIT: dteJson[ entidadReceptora ].nit,
            invoiceNRC: dteJson[ entidadReceptora ].nrc,
            invoiceEntity: dteJson[ entidadReceptora ].nombreComercial,
            invoiceEntityActivity: dteJson[ entidadReceptora ].descActividad?.concat(' (', dteJson[ entidadEmisora ].codActividad, ')'),
            // Estado de la factura
            invoiceStatus: this.invoiceStatus[ dteJson.resumen.condicionOperacion ]
          },
          body: dteJson.cuerpoDocumento,
          resume: dteJson.resumen,
          jsonToExport: { ...dteJson, 
            firmaElectronica: recepcionDte.documento,
            selloRecibido: respuestaMh.selloRecibido
          },
        }
  
        this.printedComponents.push({
          component: PrintPosFaR2NotVisible,
          data: {
            ...dataPrint
          },
          id_print: new Date().getTime(),
          codGen: dataPrint.header.invoiceCodGen
        });
      } catch (error) {
        console.log( 'Manageprint Error ', error );
      }
    },

    async downloadJsonPdf() {
      this.printedComponents = [];
      try {
        if (this.download.jsonFiles) {
          await this.reloadData({ withJSON: true })
        } else {
          await this.reloadData({ withJSON: false })
        }

        if (!this.data.length) {
          this.showError("No se encontraron comprobantes para descargar")
          return
        }

        this.$emit("setLoading", true);
        this.maxPositionArray = this.data.length;
        this.positionArray = 0;

        const invoice = this.data[this.positionArray];
        await this.SendToPrint(invoice);
      } catch (err) {
        console.log(err);
        this.cancelPrinting(err);
      }

      // this.showPrintedComponents = true;
    },

    async SendToPrint(invoice) {
      this.invoiceItems = [];
      this.totalItemsPrice = 0;
      // const data = await this.initialDataCall(
      //   invoice.InvoiceType,
      //   invoice.ID_Invoice
      // );
      this.tempData = invoice;
      this.manageprint(invoice);
      invoice.IsNDorNC = false;
      // throw new Error("Error")
    },

    onClickDownload() {
      this.showAlert(
        "question2",
        "Advertencia",
        "¿Esta seguro que desea proceder con la descarga?",
        "download"
      );
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    closeAlert() {
      this.alert.show = false;
    },
    async acceptAlert() {
      this.alert.show = false;
      if (this.alert.options === "download") {
        await this.downloadJsonPdf();
      }
    },
    showError(message) {
      this.showAlert("warning", "Advertencia", message);
    },
  },
};
</script>

<style scoped>
.btn-add {
  background-color: #00a178 !important;
  color: white;
}

.btnsave {
  background-color: #3498db !important;
  color: white;
}

.background {
  background: white !important;
  color: white;
}

.btn-position {
  position: relative;
  top: 45px;
  z-index: 1;
}

.item {
  @media screen and (min-width: 1068px) {
    position: absolute;
    z-index: 1;
  }

  @media screen and (max-width: 900px) {
    padding-bottom: 20px;
  }
}

.btn-add {
  background-color: #3498db !important;
  color: white;
}
</style>